/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { connect } from 'react-redux';
import { ReduxState } from '../../../../../ReduxStorage/state';
import { UniCard } from '.';
import { selectInstitutionFromQuery } from '../../../../../ReduxStorage/CourseMarketingFilter/selectors';
import { ConnectedUniCardProps } from './types';

const _UniCard = (props: ConnectedUniCardProps) => {
  return <UniCard {...props} />;
};

export const ConnectedUniCard = connect((state: ReduxState) => ({
  institutions: selectInstitutionFromQuery(state),
}))(_UniCard);
